import React from 'react';
import { doBuried } from '@/services/buriedService';
import { isVoid } from '@/utils/common';

/**
 * @param {Object} props
 * @param {*} props.children
 * @param {string} props.eventId
 * @param {string=} props.eventType
 * @param {string=} props.pageUrl
 * @param {string=} props.triggerEvent 默认触发事件
 * @returns
 * */
export default function BuriedWrapper({
  children,
  eventId,
  eventType,
  pageUrl,
  triggerEvent = 'onClick',
  ...props
}) {
  // 只支持单个元素
  const element = React.Children.only(children);
  const elementEventFn = element.props[triggerEvent];

  return React.cloneElement(element, {
    ...props,
    [triggerEvent]: (...args) => {
      if (!isVoid(eventId)) {
        doBuried({ eventId, eventType, pageUrl });
      }
      if (typeof elementEventFn === 'function') {
        elementEventFn(...args);
      }
    },
  });
}
